module.exports = __webpack_public_path__ + "media/images/ecalls/bitcoin_people-1229a9d290fe7befd7afa9bcb8dbb1d7.png";